import Mapper from '@/models/mappers/Mapper';
import { Category } from '@/models/entities/Category';
import { CategoryDTO } from '@/api/dto/CategoryDTO';
import { mapValueToInterface } from '@/utils/models';
import { ProductCategoryOptionMapper } from '@/models/mappers/ProductCategoryOptionMapper';

const optionMapper = new ProductCategoryOptionMapper();

export class CategoryMapper extends Mapper<Category, CategoryDTO> {
  mapFromDTO(categoryDTO: CategoryDTO): Category {
    const category = new Category(<Partial<Category>>categoryDTO);
    category.productCategoryOptions = (categoryDTO.productCategoryOptions || []).map(
      opt => optionMapper.mapFromDTO(opt),
    );
    return category;
  }

  mapToDTO(category: Category): CategoryDTO {
    return mapValueToInterface(category) as CategoryDTO;
  }
}
